import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerified = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5Z",
		fill: "#FBC02D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 16.9997L6 12.9997L7.41 11.5897L10 14.1697L16.59 7.57971L18 8.99971L10 16.9997Z",
		fill: "#2F2A2A"
	})]
});
export default SvgVerified;
